import terms from "@/terms"

export const useJobs = () => {
  const jobs = [
    {
      field: "priority_law",
      title: "Any lawyer job",
      description: terms.lawFirm,
    },
    {
      field: "priority_firm",
      title: "Any law firm job",
      description: terms.firm,
    },
    {
      field: "priority_biglaw",
      title: "Large firm",
      description: terms.bigLaw,
    },
    {
      field: "priority_public",
      title: "Public service",
      description: terms.publicService,
    },
    {
      field: "priority_clerk",
      title: "Clerkship",
      description: terms.clerkship,
    },
  ]

  return { jobs }
}
